import { migrationContext } from '../../migrationUsersBranchView.poeditor';

export const videocallInfoKeys = {
  headerLeftText: `${migrationContext}-mbMigrationHeaderVideocallsIdentification`,
  title: `${migrationContext}-mbMigrationVideocallIdentificationTitle`,
  bullet01Title: `${migrationContext}-mbMigrationVideocallIdentificationBullet01Title`,
  bullet01Description: `${migrationContext}-mbMigrationVideocallIdentificationBullet01Description`,
  bullet02Title: `${migrationContext}-mbMigrationVideocallIdentificationBullet02Title`,
  bullet02Description: `${migrationContext}-mbMigrationVideocallIdentificationBullet02Description`,
  bullet03Title: `${migrationContext}-mbMigrationVideocallIdentificationBullet03Title`,
  bullet03Description: `${migrationContext}-mbMigrationVideocallIdentificationBullet03Description`,
  infoMessageTitle: `${migrationContext}-mbMessageTakeInMindInformationTitle`,
  infoMessageDescription: `${migrationContext}-mbMessageTakeInMindInformationDescriptionIdentificationDoneByWebID`,
  continueButton: `${migrationContext}-mbMigrationLetsGoButton`,
};
